import {
  Box,
  Card,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Skeleton,
} from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import styles from "./style.module.scss";
// import { Icons } from "assets";
import moment from "moment";
import { scrollToElementTop } from "shared/utils/helpers";
import CustomButton from "shared/components/customButton";
import {
  allMouService,
  deleteMOUService,
  getSingleMOUService,
  rejectMOUService,
  signatureMOUService,
  signatureOnlyMOUService,
  // assignToHeadService,
  // createMOUService,
  // deleteMOUService,
  // updateMOUService,
} from "shared/services/projectHeadService";
import { toastMessage } from "shared/components/toast";
import { useFormik } from "formik";
import { useLocation, useParams } from "react-router-dom";
import { MOUSchema } from "shared/utils/validationSchemas";
import Loader from "shared/components/loader/animation";
import Confirmation from "shared/modals/confirmation";
import { Icons } from "assets";
import SignatureCanvas from "react-signature-canvas";
import useBreadcrumbs from "shared/customHooks/useBreadCrumbs";
import { routeConstant } from "shared/routes/routesConstant";
import classNames from "classnames";

const radioOptions = [
  {
    label: "Draw Signature",
    value: 0,
  },
  {
    label: "Upload Image",
    value: 1,
  },
];

function MOU() {
  const { id } = useParams<{ id: string }>() as { id: string };
  const location = useLocation();
  const signatureRef = useRef<any>(null);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const detailRef = useRef<HTMLDivElement | null>(null);
  const [allMous, setAllMous] = useState<any>(null);
  const [mouLoader, setMouLoader] = useState<boolean>(true);
  const [selectedMOU, setSelectedMOU] = useState<any>(null);
  const [loader, setLoader] = useState<boolean>(false);
  const [submitLoader, setSubmitLoader] = useState<boolean>(false);
  const [inReview, setInReview] = useState<boolean>(false);
  const [singleLoader, setSingleLoader] = useState<boolean>(false);
  const [openConfirm, setOpenConfirmation] = useState<boolean>(false);
  const [action, setAction] = useState<any>({
    label: "",
    type: "",
  });
  const [selectedOption, setSelectedOption] = useState<any>(radioOptions[0]);
  const [image, setImage] = useState<any>({
    preview: "",
    raw: null,
  });
  const [editAllowed, setEditAllowed] = useState<boolean>(false);
  const [isB2BChecked, setIsB2BChecked] = useState(false);
  const [selectedValue, setSelectedValue] = useState("pkr");
  const handleB2BChange = () => {
    setIsB2BChecked(!isB2BChecked);
  };
  useEffect(() => {
    if (selectedMOU?.is_international === 0) {
      setSelectedValue("pkr")
    } else {
      setSelectedValue("usd")

    }
  }, [selectedMOU])
  const getAllMous = () => {
    setMouLoader(true);
    allMouService(id)
      .then(({ data }) => {
        setMouLoader(false);
        setAllMous(data?.data);
        setSelectedMOU(data?.data[0]);
      })
      .catch((err) => {
        setMouLoader(false);
        toastMessage("error", err?.response?.data?.message);
        console.log("err", err?.response?.data?.message);
      });
  };

  let initialValues = {
    description: "",
    freeBooksLimit: "",
    premiumBooksLimit: "",
    platformFee: "",
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: MOUSchema,
    onSubmit: (values) => {
      // const signatureCanvas = signatureRef.current;
      // const isSigned = signatureCanvas?.isEmpty();

      // if (selectedOption.value === 0 && isSigned) {
      //   toastMessage("error", "Please sign to proceed.");
      // } else if (selectedOption.value === 1 && !image?.raw) {
      //   toastMessage("error", "Please upload image to proceed.");
      // } else {
      handleSubmit(values);
      // }
    },
  });

  const signHandler = () => {
    const signatureCanvas = signatureRef.current;
    const isSigned = signatureCanvas?.isEmpty();

    // Validate signature before proceeding
    if (selectedOption.value === 0 && isSigned) {
      toastMessage("error", "Please sign to proceed.");
      return; // Exit function if no signature drawn
    } else if (selectedOption.value === 1 && !image?.raw) {
      toastMessage("error", "Please upload image to proceed.");
      return; // Exit function if no image uploaded
    }

    let signatureData = signatureRef?.current?.toDataURL();

    let sigResp: any = {
      mou_id: selectedMOU?.id,
      signature_type: selectedOption?.value + 1,
    };
    if (selectedOption.value === 0) {
      sigResp["signature"] = signatureData;
    }

    if (selectedOption.value === 1) {
      sigResp["signature_file"] = image.raw;
    }

    let sigFormBody = new FormData();
    Object.keys(sigResp).forEach((key) => {
      sigFormBody.append(key, sigResp[key]);
    });

    setSubmitLoader(true);
    signatureOnlyMOUService(sigFormBody)
      .then(({ data }) => {
        toastMessage("success", data?.message);
        setSubmitLoader(false);
        getAllMous();
        setSelectedMOU(null);
        formik.resetForm();
      })
      .catch((err) => {
        console.log("err", err?.response?.data?.message);
        toastMessage("error", err?.response?.data?.message);
        setSubmitLoader(false);
      });
  };

  useEffect(() => {
    if (selectedMOU?.is_international === 1) {
      setSelectedValue("usd");
    } else {
      setSelectedValue("pkr");
    }
  }, [selectedMOU]);

  const handleSubmit = (values: any) => {
    // let signatureData = signatureRef?.current?.toDataURL();

    // let resp: any = {
    //   mou_id: selectedMOU?.id,
    //   agreement: values?.description,
    //   free_book_ratio: values?.freeBooksLimit,
    //   total_books: values?.premiumBooksLimit,
    //   platform_commission: values?.platformFee,
    //   // signature_type: selectedOption?.value + 1,
    // };
    // // Append each revenue type individually
    const formData = new FormData();
    formData.append("user_id", id as any);
    formData.append("agreement", values?.description);
    formData.append("free_book_ratio", values?.freeBooksLimit);
    formData.append("total_books", values?.premiumBooksLimit);
    formData.append("platform_commission", values?.platformFee);
    if (selectedMOU?.id) {
      formData.append("mou_id", selectedMOU?.id);
    }

    if (selectedValue === "pkr") {
      formData.append("is_international", '0');
    } else {
      formData.append("is_international", '1');
    }

    // Append each revenue type individually
    formData.append("revenue_types[]", "1");
    if (isB2BChecked) {
      formData.append("revenue_types[]", "2");
    }

    // if (selectedOption.value === 0) {
    //   resp["signature"] = signatureData;
    // }

    // if (selectedOption.value === 1) {
    //   resp["signature_file"] = image.raw;
    // }

    // let formBody = new FormData();
    // Object.keys(resp).forEach((key) => {
    //   formBody.append(key, resp[key]);
    // });

    setSubmitLoader(true);
    signatureMOUService(formData)
      .then(({ data }) => {
        toastMessage("success", data?.message);
        setSubmitLoader(false);
        getAllMous();
        setSelectedMOU(null);
        formik.resetForm();
      })
      .catch((err) => {
        console.log("err", err?.response?.data?.message);
        toastMessage("error", err?.response?.data?.message);
        setSubmitLoader(false);
      });
  };

  useEffect(() => {
    getAllMous();
    // eslint-disable-next-line
  }, []);

  const handleCloseConfirmation = () => {
    setOpenConfirmation(false);
    setAction({
      label: "",
      type: "",
    });
  };

  const handleOpenConfirmation = (label: String, type: String) => {
    setOpenConfirmation(true);
    setAction({
      label: label,
      type: type,
    });
  };

  const handleActions = (action: any) => {
    if (action.type === "reject") {
      setLoader(true);
      // deleteMOUService(selectedMOU?.id)
      rejectMOUService(selectedMOU?.id)
        .then(({ data }) => {
          toastMessage("success", data?.message);
          setLoader(false);
          getAllMous();
          handleCloseConfirmation();
        })
        .catch((err) => {
          console.log("err", err?.response?.data?.message);
          toastMessage("error", err?.response?.data?.message);
          setLoader(false);
        });
    }
  };
  useEffect(() => {
    if (selectedMOU) {
      const revenueTypes = selectedMOU?.revenue_models || [];
      const hasType2 = revenueTypes.some((model: any) => model.type === 2);
      setIsB2BChecked(hasType2);
    }
  }, [selectedMOU]);
  const getMOU = () => {
    setSingleLoader(true);
    getSingleMOUService(selectedMOU.id)
      .then(({ data }) => {
        setSingleLoader(false);
        setEditAllowed(data?.data?.status === 3);
        setInReview(data?.data?.status === 1);
        formik.setFieldValue("freeBooksLimit", data?.data?.free_book_ratio);
        formik.setFieldValue("description", data?.data?.agreement);
        formik.setFieldValue("premiumBooksLimit", data?.data?.total_books);
        formik.setFieldValue("platformFee", data?.data?.platform_commission);
      })
      .catch((err) => {
        console.log("error", err?.response?.data?.message);
        toastMessage("error", err?.response?.data?.message);
        setSingleLoader(false);
      });
  };

  useEffect(() => {
    if (selectedMOU) {
      getMOU();
    }
    // eslint-disable-next-line
  }, [selectedMOU]);

  const handleClear = () => {
    if (signatureRef.current) {
      signatureRef.current.clear();
    }
  };

  const handleImageChange = (e: any) => {
    const file = e.target.files && e.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onload = (e: any) => {
        setImage({
          preview: e.target.result as string,
          raw: file,
        });
      };

      reader.readAsDataURL(file);
    }
  };

  const handleRemoveImage = (event: any) => {
    event.preventDefault();
    setImage({ preview: "", raw: null });
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const MOU_STATUS = [
    { label: "Draft", value: 0 },
    { label: "Review", value: 1 },
    { label: "Pending", value: 2 },
    { label: "Accepted", value: 3 },
    { label: "Declined", value: 4 },
    { label: "Rejected", value: 5 },
    { label: "Completed", value: 7 },
  ];

  useBreadcrumbs(
    {
      title: location?.state?.user?.full_name,
      path: routeConstant.mouHead.path.replace(":id", id),
    },
    true,
    location?.state
  );
  const MOU_STATUSES = {
    draft: 0,
    review: 1,
    pending: 2,
    accepted: 3,
    declined: 4,
    rejected: 5,
    completed: 7,
  };

  const hasCompletedMOU = (mous: any[]): boolean => {
    return mous?.some(mou => mou.status === MOU_STATUSES.completed);
  };

  return (
    <div>
      {
        <Grid container spacing={2}>

          <Grid item xs={12} md={allMous?.length === 0 ? 12 : 3}>
            {mouLoader ? (
              Array.from({ length: 3 }).map((_, index) => (
                <Skeleton
                  variant="rectangular"
                  width={"100%"}
                  height={"120px"}
                  sx={{ borderRadius: "10px", marginBottom: "20px" }}
                />
              ))
            ) : (
              <>
                <Box>
                  {allMous?.length ? (
                    allMous?.map((item: any, inx: any, array: any) => {
                      return (
                        <div
                          className={
                            item?.id === selectedMOU?.id
                              ? styles.activeMOU
                              : styles.singleMOU
                          }
                          key={inx}
                          onClick={() => {
                            setSelectedMOU(item);
                            scrollToElementTop(detailRef.current);
                          }}
                        >
                          <div className={styles[statusClass(item.status)]}>
                            {
                              MOU_STATUS.find(
                                (itm) => item.status === itm.value
                              )?.label
                            }
                          </div>

                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <div className={styles.mouHeading}>
                              Agreement {array.length - inx}
                            </div>
                            <div className={styles.mouDate}>
                              {moment(item?.created_at).format("DD-MM-YYYY")}
                            </div>
                          </div>
                          <div className={styles.agreement}>
                            {item?.agreement}
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div className={styles.noUserCard}>
                      <Icons.NoDataIcon />
                      <h5>No Data Found</h5>
                    </div>
                  )}
                </Box>
              </>
            )}
          </Grid>
          <Grid
            sx={allMous?.length === 0 ? { display: "none" } : {}}
            ref={detailRef}
            item
            xs={12}
            md={9}
          >
            {mouLoader ? (
              <Card>
                <Skeleton
                  variant="rectangular"
                  width={"100%"}
                  height={"500px"}
                />
              </Card>
            ) : (
              <Card className={styles.mouEditorContainer}>
                <div className={styles.mouInnerContainer}>
                  <div className={styles.mouLabel}>
                    {selectedMOU?.status === 1
                      ? "Review Agreement"
                      : selectedMOU?.status === 2
                        ? "Waiting for Partner Signature"
                        : selectedMOU?.status === 3
                          ? "Sign Agreement"
                          : selectedMOU?.status === 4
                            ? "Agreement Declined By Partner"
                            : selectedMOU?.status === 5
                              ? "Agreement Rejected By Project Head"
                              : selectedMOU?.status === 7
                                ? "Agreement Signed"
                                : ""}
                  </div>
                  <div className={styles.mouHeading}>
                    Date:{" "}
                    {moment(
                      new Date(
                        selectedMOU?.created_at
                          ? selectedMOU?.created_at
                          : new Date()
                      )
                    ).format("D/M/yyyy")}
                  </div>
                </div>
                <form onSubmit={formik.handleSubmit}>
                  <>
                    <div className={styles.mouHeading}>
                      Agreement Description <span>*</span>
                    </div>
                    {!singleLoader ? (
                      <textarea
                        className={styles.textarea}
                        id="description"
                        name="description"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.description}
                        disabled={
                          editAllowed ||
                          selectedMOU?.status === 7 ||
                          selectedMOU?.status === 2 ||
                          selectedMOU?.status === 4 ||
                          selectedMOU?.status === 5
                        }
                      />
                    ) : (
                      <Skeleton
                        variant={"rectangular"}
                        width={"100%"}
                        height={"250px"}
                        sx={{ borderRadius: "20px", marginTop: "10px" }}
                      />
                    )}
                    {formik.touched.description && formik.errors.description ? (
                      <div className={styles.errorText}>
                        {formik?.errors?.description}
                      </div>
                    ) : (
                      <div style={{ height: "20px" }}></div>
                    )}

                    <Grid container sx={{ marginTop: "20px" }}>
                      <Grid xs={4}>
                        <div className={styles.titleHead}>Free Books Limit</div>
                        {singleLoader ? (
                          <Skeleton
                            variant="rectangular"
                            width={"98%"}
                            height={"45px"}
                            sx={{ borderRadius: "32px" }}
                          />
                        ) : (
                          <input
                            className={styles.input}
                            id="freeBooksLimit"
                            name="freeBooksLimit"
                            type="text"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.freeBooksLimit}
                            disabled={
                              editAllowed ||
                              selectedMOU?.status === 7 ||
                              selectedMOU?.status === 2 ||
                              selectedMOU?.status === 4 ||
                              selectedMOU?.status === 5
                            }
                          />
                        )}
                        {formik.touched.freeBooksLimit &&
                          formik.errors.freeBooksLimit ? (
                          <div className={styles.errorText}>
                            {formik.errors.freeBooksLimit}
                          </div>
                        ) : (
                          <div style={{ height: "20px" }}></div>
                        )}
                      </Grid>

                      <Grid xs={4}>
                        <div className={styles.titleHead}>
                          Premium Books Limit
                        </div>
                        {singleLoader ? (
                          <Skeleton
                            variant="rectangular"
                            width={"98%"}
                            height={"45px"}
                            sx={{ borderRadius: "32px" }}
                          />
                        ) : (
                          <input
                            className={styles.input}
                            id="premiumBooksLimit"
                            name="premiumBooksLimit"
                            type="text"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.premiumBooksLimit}
                            disabled={
                              editAllowed ||
                              selectedMOU?.status === 7 ||
                              selectedMOU?.status === 2 ||
                              selectedMOU?.status === 4 ||
                              selectedMOU?.status === 5
                            }
                          />
                        )}
                        {formik.touched.premiumBooksLimit &&
                          formik.errors.premiumBooksLimit ? (
                          <div className={styles.errorText}>
                            {formik.errors.premiumBooksLimit}
                          </div>
                        ) : (
                          <div style={{ height: "20px" }}></div>
                        )}
                      </Grid>

                      <Grid xs={4}>
                        <div className={styles.titleHead}>Platform Fee</div>
                        {singleLoader ? (
                          <Skeleton
                            variant="rectangular"
                            width={"98%"}
                            height={"45px"}
                            sx={{ borderRadius: "32px" }}
                          />
                        ) : (
                          <input
                            className={styles.input}
                            id="platformFee"
                            name="platformFee"
                            type="text"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.platformFee}
                            disabled={
                              editAllowed ||
                              selectedMOU?.status === 7 ||
                              selectedMOU?.status === 2 ||
                              selectedMOU?.status === 4 ||
                              selectedMOU?.status === 5
                            }
                          />
                        )}
                        {formik.touched.platformFee &&
                          formik.errors.platformFee ? (
                          <div className={styles.errorText}>
                            {formik.errors.platformFee}
                          </div>
                        ) : (
                          <div style={{ height: "20px" }}></div>
                        )}
                      </Grid>
                    </Grid>
                  </>
                  <div className={styles.mainContanier}>

                    <div>
                      <h3 className={styles.mouHeading}>Revenue Models</h3>
                      <div className={classNames(styles.checkboxContainer)}>
                        <div className={classNames(styles.checkboxWrapper)}>
                          <input
                            disabled
                            checked
                            type="checkbox"
                            id="subscription"
                            className={styles.checkboxInput}
                          />
                          <label className={styles.checkboxLabel} htmlFor="subscription">
                            Subscription
                          </label>
                        </div>
                        <div className={classNames(styles.checkboxWrapper)}>
                          <input
                            type="checkbox"
                            id="b2b"
                            disabled={editAllowed ||
                              selectedMOU?.status === 7 ||
                              selectedMOU?.status === 2 ||
                              selectedMOU?.status === 4 ||
                              selectedMOU?.status === 5}
                            checked={isB2BChecked}
                            onChange={handleB2BChange}
                            className={styles.checkboxInput}
                          />
                          <label className={styles.checkboxLabel} htmlFor="b2b">
                            B2B
                          </label>
                        </div>
                      </div>
                    </div>

                    <div>
                      <h3 className={styles.mouHeading}>Currency Type</h3>
                      {(!hasCompletedMOU(allMous) && selectedMOU?.status !== MOU_STATUSES.completed) ? (
                        <div className={classNames(styles.checkboxContainer)}>
                          <div className={classNames(styles.checkboxWrapper)}>
                            <input
                              type="radio"
                              id="pkr"
                              className={styles.radioStyle}
                              value='pkr'
                              disabled={editAllowed ||
                                selectedMOU?.status === 7 ||
                                selectedMOU?.status === 2 ||
                                selectedMOU?.status === 4 ||
                                selectedMOU?.status === 5}
                              checked={selectedValue === "pkr"}
                              onChange={(e) => setSelectedValue(e.target.value)}
                              name="location"
                            />
                            <label className={styles.checkboxLabel} htmlFor="pkr">
                              Pakistan
                            </label>
                          </div>
                          <div className={classNames(styles.checkboxWrapper)}>
                            <input
                              type="radio"
                              id="usd"
                              value='usd'
                              disabled={editAllowed ||
                                selectedMOU?.status === 7 ||
                                selectedMOU?.status === 2 ||
                                selectedMOU?.status === 4 ||
                                selectedMOU?.status === 5}
                              checked={selectedValue === "usd"}
                              onChange={(e) => setSelectedValue(e.target.value)}
                              className={styles.radioStyle}
                              name="location"
                            />
                            <label className={styles.checkboxLabel} htmlFor="usd">
                              International
                            </label>
                          </div>
                        </div>
                      ) : (
                        <div className={styles.agreement}>
                          Currency: {selectedValue === "pkr" ? "PKR" : "USD"}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className={styles.signatureContainer}>
                    {selectedMOU?.admin_signature && (
                      <div>
                        {singleLoader ? (
                          <Skeleton
                            variant="rectangular"
                            width="155px"
                            height="65px"
                          />
                        ) : (
                          <img
                            src={selectedMOU?.admin_signature}
                            className={styles.signatureImg}
                            alt="signature"
                          />
                        )}
                        <div className={styles.line}></div>
                        <div className={styles.titleHead}>Admin Signature</div>
                      </div>
                    )}
                    {selectedMOU?.user_signature && (
                      <div>
                        {" "}
                        {singleLoader ? (
                          <Skeleton
                            variant="rectangular"
                            width="155px"
                            height="65px"
                          />
                        ) : (
                          <img
                            src={selectedMOU?.user_signature}
                            className={styles.signatureImg}
                            alt="signature"
                          />
                        )}
                        <div className={styles.line}></div>
                        <div className={styles.titleHead}>User Signature</div>
                      </div>
                    )}
                  </div>
                  {/* )} */}

                  {editAllowed && (
                    <>
                      <div className={styles.mouHeading}>
                        Signature <span>*</span>
                      </div>
                      <FormControl>
                        <RadioGroup
                          aria-labelledby="demo-controlled-radio-buttons-group"
                          name="controlled-radio-buttons-group"
                          value={selectedOption.value}
                          onChange={(e) => {
                            setSelectedOption(
                              radioOptions?.find(
                                (item) => Number(e.target.value) === item?.value
                              )
                            );
                          }}
                          sx={{ flexDirection: "row" }}
                        >
                          {radioOptions?.map((option: any, index: number) => (
                            <div className={styles.radio} key={index}>
                              <FormControlLabel
                                value={option.value}
                                control={<Radio />}
                                label={""}
                                name={option.label}
                                checked={option.value === selectedOption.value}
                              />
                              <span className={styles.subHeading}>
                                {option?.label}
                              </span>
                            </div>
                          ))}
                        </RadioGroup>
                      </FormControl>
                      {selectedOption.value === 0 && (
                        <div style={{ position: "relative" }}>
                          <SignatureCanvas
                            ref={signatureRef}
                            penColor="black"
                            canvasProps={{
                              width: 400,
                              height: 200,
                              className: styles.signatureCanvas,
                            }}
                          />
                          <div>
                            <input
                              type="file"
                              accept="image/*"
                              onChange={handleImageChange}
                              ref={fileInputRef}
                              style={{ display: "none" }}
                            />
                          </div>{" "}
                          <div
                            className={styles.clear}
                            onClick={() => handleClear()}
                          >
                            Clear
                          </div>
                        </div>
                      )}

                      {selectedOption.value === 1 ? (
                        !image?.preview ? (
                          <div
                            className={styles.nonImgContainer}
                            onClick={handleButtonClick}
                          >
                            <input
                              type="file"
                              accept="image/*"
                              onChange={handleImageChange}
                              ref={fileInputRef}
                              style={{ display: "none" }}
                            />
                            <Icons.UploadImgIcon />
                          </div>
                        ) : (
                          <>
                            <div className={styles.nonImgContainer}>
                              <input
                                type="file"
                                accept="image/*"
                                onChange={handleImageChange}
                                ref={fileInputRef}
                                style={{ display: "none" }}
                              />
                              <img
                                src={image.preview}
                                alt={"user"}
                                className={styles.uploadPicture}
                                onClick={handleButtonClick}
                              />
                              <CustomButton
                                text={"Clear"}
                                buttonStyle={styles.clearBtn}
                                handleClick={(e: any) => handleRemoveImage(e)}
                              />
                            </div>
                          </>
                        )
                      ) : null}
                    </>
                  )}

                  <Box
                    display={"flex"}
                    justifyContent={"end"}
                    marginTop={"40px"}
                  >
                    {editAllowed && (
                      <CustomButton
                        text={"Sign Agreement"}
                        buttonStyle={styles.btnInside}
                        handleClick={signHandler}
                        type="button"
                        loader={submitLoader}
                      />
                    )}
                    {inReview && (
                      <>
                        <CustomButton
                          text={"Accept Agreement"}
                          buttonStyle={styles.btnInside}
                          type="Submit"
                          loader={submitLoader}
                        />
                        <CustomButton
                          text={"Reject"}
                          buttonStyle={styles.btn}
                          handleClick={(e: any) => {
                            e.preventDefault();
                            handleOpenConfirmation(
                              "Are you sure you want to reject this Agreement?",
                              "reject"
                            );
                          }}
                        />
                      </>
                    )}
                  </Box>
                </form>{" "}
                {loader && <Loader />}
              </Card>
            )}
            <Confirmation
              open={openConfirm}
              handleClose={() => handleCloseConfirmation()}
              handleClick={() => handleActions(action)}
              text={action.label}
              loader={loader}
            />
          </Grid>
        </Grid>
      }
    </div>
  );
}

export default MOU;

function statusClass(status: number): string {
  const statusClasses: Record<number, string> = {
    3: "agreed",
    4: "declined",
  };
  return statusClasses[status] || "pending";
}
